import axios from 'axios';
import { responseError } from '../../helpers/responsePortal';

const baseAxios = axios.create({
    baseURL: `${process.env.REACT_APP_ECOMMERCE_ENDPOINT}`
});

baseAxios.interceptors.response.use(
    (response) => response,
    (error) => responseError(error),
);

export default baseAxios;